import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String,
  };

  async sendTest() {
    try {
      const response = await get(this.urlValue, { responseKind: "json" });
      if (!response.ok) {
        console.error("通知テストの送信に失敗しました");
      }
    } catch (error) {
      console.error("通知テストの送信中にエラーが発生しました:", error);
    }
  }
}
